(function () {
	'use strict';

	angular.module('qbePortal').directive('mutualExclusiveValidation', function () {

		return {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				mutualExclusiveValidation: "="
			},
			link: function (scope, elm, attrs, ngModel) {
				// only apply the validator if ngModel is present and Angular has added the email validator
				elm.change(function () {

					if (scope.mutualExclusiveValidation) {
						//atleast 1 option should be present for the validation to function
						if (scope.mutualExclusiveValidation.exclusiveOptions.length > 1) {
							var optionValue = attrs.value;

							//Is the current element one of the mutually exclusive options
							var isRequiredForValidation = scope.mutualExclusiveValidation.exclusiveOptions.indexOf(optionValue) > -1;
							if (isRequiredForValidation) {

								//Get the state of that option and proceed with the validation if true
								if (scope.mutualExclusiveValidation.modelValue[attrs.value]) {
									scope.mutualExclusiveValidation.exclusiveOptions.forEach(function(item){
										if(item!=optionValue){
											scope.mutualExclusiveValidation.modelValue[item] = false;
										}
									})
									scope.$apply();
								}
							}
						}
					}
				});
			}
		};
	});
})();
